export const RESET = "RESET";

//benchmark
export const UPDATE_BENCHMARK_SETTING = "UPDATE_BENCHMARK_SETTING";
export const SET_BENCHMARK_HOLDINGS = "SET_BENCHMARK_HOLDINGS";
export const SET_BENCHMARK_TYPE = "SET_BENCHMARK_TYPE";
export const SET_CUSTOMBENCHMARK_ID = "SET_CUSTOMBENCHMARK_ID";
export const SET_CUSTOMBENCHMARK_NAME = "SET_CUSTOMBENCHMARK_NAME";
export const SET_INCLUDE_BENCHMARK = "SET_INCLUDE_BENCHMARK";

//fees
export const UPDATE_FEE_SETTING = "UPDATE_FEE_SETTING";
export const SET_FEE_SETTING = "SET_FEE_SETTING";
export const SET_INCLUDE_ADVISORY_FEE = "SET_INCLUDE_ADVISORY_FEE";
export const SET_INCLUDE_TRANSACTION_FEE = "SET_INCLUDE_TRANSACTION_FEE";
export const SET_ANNUAL_FEE_AMOUNT = "SET_ANNUAL_FEE_AMOUNT";
export const SET_ANNUAL_FEE_CHARGE_FREQUENCY = "SET_ANNUAL_FEE_CHARGE_FREQUENCY";
export const SET_ANNUAL_FEE_PAY_METHOD = "SET_ANNUAL_FEE_PAY_METHOD";
export const SET_ANNUAL_FEE_PAY_ON_BEGIN = "SET_ANNUAL_FEE_PAY_ON_BEGIN";
export const SET_ANNUAL_FEE_PAY_CASH_FIRST = "SET_ANNUAL_FEE_PAY_CASH_FIRST";
export const SET_FRONT_LOAD_TYPE = "SET_FRONT_LOAD_TYPE";
export const SET_FRONT_LOAD_AMOUNT = "SET_FRONT_LOAD_AMOUNT";
export const SET_FRONT_LOAD_AMOUNT_TYPE = "SET_FRONT_LOAD_AMOUNT_TYPE";
export const SET_LOI = "SET_LOI";
export const SET_REDEMPTION_CHARGE = "SET_REDEMPTION_CHARGE";
export const SET_CHARGE_ON_REBALANCING = "SET_CHARGE_ON_REBALANCING";

// taxes
export const UPDATE_TAX_SETTING = "UPDATE_TAX_SETTING";
export const CALCULATE = "CALCULATE";
export const SET_TAXRATE_INFO = "SET_TAXRATE_INFO";
export const SET_FILING_STATUSES = "SET_FILING_STATUSES";
export const SET_INCLUDE_TAX = "SET_INCLUDE_TAX";
export const SET_TAXFILINGSTATUS = "SET_FILING_STATUS_ID";
export const SET_TAXABLEINCOME = "SET_TAXABLEINCOME";
export const SET_TAXPAYTYPE = "SET_PAYOPTION";
export const SET_FEDERALTAXRATE = "SET_FEDERAL_INCOME";
export const SET_STATETAXRATE = "SET_STATE";
export const SET_CAPGAINTAXRATE = "SET_CAPITALGAIN";

//rebalancing
export const SET_REBALANCE_SECURITIES = "SET_REBALANCE_SECURITIES";
export const SET_INCLUDE_REBALANCE = "SET_INCLUDE_REBALANCE";
export const SET_REBALANCE_TYPE = "SET_REBALANCE_TYPE";
export const SET_FREQUENCY_TYPE = "SET_FREQUENCY_TYPE";
export const SET_THRESHOLD = "SET_THRESHOLD";
export const SET_REBALANCE_SETTING = "SET_REBALANCE_SETTING";

//holdings
export const SET_SECURITIES = "SET_SECURITIES";
export const SET_ASSET_ALLOCATIONS = "SET_ASSET_ALLOCATIONS";

//transaction
export const SET_INCLUDE_REINVESTMENT = "SET_INCLUDE_REINVESTMENT";
export const SET_INCLUDE_CONTRIBUTION_AND_WITHDRAWAL = "SET_INCLUDE_CONTRIBUTION_AND_WITHDRAWAL";
export const SET_REINVESTMENT_SETTING = "SET_REINVESTMENT_SETTING";
export const SET_SUB_SEQUENT_SETTING = "SET_SUB_SEQUENT_SETTING";
export const SET_REINVEST_CAPITAL_GAINS = "SET_REINVEST_CAPITAL_GAINS";
export const SET_REINVEST_DIVIDENDS = "SET_REINVEST_DIVIDENDS";
export const SET_LIQUIDATE_ON_END_DATE = "SET_LIQUIDATE_ON_END_DATE";
export const SET_SUB_SEQUENTS = "SET_SUB_SEQUENTS";

//settings
export const SET_CURRENCY = "SET_CURRENCY";
export const SET_ALLOCATE_BY = "SET_ALLOCATE_BY";
export const SET_INITIAL_INVESTMENT_AMOUNT = "SET_INITIAL_INVESTMENT_AMOUNT";
export const SET_RAW_PORTFOLIO = "SET_RAW_PORTFOLIO";
export const SET_PREFERENCES = "SET_PREFERENCES";
export const SET_CURRENCY_LIST = "SET_CURRENCY_LIST";
export const SET_ASSET_ALLOCATION = "SET_ASSET_ALLOCATION";
export const SET_IS_APPLY_EARLIEST_AVAILABLE = "SET_IS_APPLY_EARLIEST_AVAILABLE";
export const SET_HYPO_TYPE = "SET_HYPO_TYPE";
